import { Amount, Unit } from 'uom';
import { Decimal } from 'decimal.js-light';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

export function convert<T>(
    value: string,
    from: Unit.Unit<T>,
    to: Unit.Unit<T>,
    defaultValue = '',
    decimalPlaces = DECIMAL_DIGITS,
) {
    try {
        const amount = Amount.create(new Decimal(value).toNumber(), from);
        return Amount.valueAs(to, amount).toFixed(decimalPlaces);
    } catch {
        return defaultValue;
    }
}
